const workflows = 'workflows';

/*------------------------------------------------------------------------------------------------*/
/* Workflows Action Types                                                                         */
/*------------------------------------------------------------------------------------------------*/

/** Create Actions */
export const CREATE_WORKFLOW_DRAFT_REQUEST = `${workflows}/CREATE_WORKFLOW_DRAFT_REQUEST`;
export const CREATE_WORKFLOW_DRAFT_RESPONSE = `${workflows}/CREATE_WORKFLOW_DRAFT_RESPONSE`;

/** Fetch Actions */
export const FETCH_WORKFLOW_REQUEST = `${workflows}/FETCH_WORKFLOW_REQUEST`;
export const FETCH_WORKFLOW_RESPONSE = `${workflows}/FETCH_WORKFLOW_RESPONSE`;
export const FETCH_WORKFLOW_ERROR = `${workflows}/FETCH_WORKFLOW_ERROR`;

/** Update Actions */
export const UPDATE_WORKFLOW = `${workflows}/UPDATE_WORKFLOW`;
export const UPDATE_HAS_UNSAVED_CHANGES = `${workflows}/UPDATE_HAS_UNSAVED_CHANGES`;

export const SAVE_WORKFLOW_DRAFT_REQUEST = `${workflows}/SAVE_WORKFLOW_DRAFT_REQUEST`;
export const SAVE_WORKFLOW_DRAFT_RESPONSE = `${workflows}/SAVE_WORKFLOW_DRAFT_RESPONSE`;
export const SAVE_WORKFLOW_ERROR = `${workflows}/SAVE_WORKFLOW_ERROR`;
export const PUBLISH_WORKFLOW_DRAFT_REQUEST = `${workflows}/PUBLISH_WORKFLOW_DRAFT_REQUEST;`;

export const RESET_WORKFLOW_DRAFT_REQUEST = `${workflows}/RESET_WORKFLOW_DRAFT_REQUEST`;
export const RESET_WORKFLOW_DRAFT_RESPONSE = `${workflows}/RESET_WORKFLOW_DRAFT_RESPONSE`;
export const RESET_WORKFLOW_DRAFT_ERROR = `${workflows}/RESET_WORKFLOW_DRAFT_ERROR`;

/* Campaign Actions */
export const UPSERT_WORKFLOW_CAMPAIGN_REQUEST = `${workflows}/UPSERT_WORKFLOW_CAMPAIGN_REQUEST`;
export const UPSERT_WORKFLOW_CAMPAIGN_LOADING = `${workflows}/UPSERT_WORKFLOW_CAMPAIGN_LOADING`;

/** Undo/Redo Actions */
export const UNDO_ACTION = `${workflows}/UNDO_ACTION`;
export const REDO_ACTION = `${workflows}/REDO_ACTION`;

/** Other Actions */

export const UPDATE_WORKFLOW_METRICS = `${workflows}/UPDATE_WORKFLOW_METRICS`;

export const UPDATE_WORKFLOW_STATUS_REQUEST = `${workflows}/UPDATE_WORKFLOW_STATUS_REQUEST`;
export const UPDATE_WORKFLOW_STATUS_RESPONSE = `${workflows}/UPDATE_WORKFLOW_STATUS_RESPONSE`;
export const UPDATE_WORKFLOW_STATUS_ERROR = `${workflows}/UPDATE_WORKFLOW_STATUS_ERROR`;

export const TEST_TRIGGER_REQUEST = `${workflows}/TEST_TRIGGER_REQUEST`;
export const TEST_TRIGGER_RESPONSE = `${workflows}/TEST_TRIGGER_RESPONSE`;
export const TEST_TRIGGER_ERROR = `${workflows}/TEST_TRIGGER_ERROR`;

export const FETCH_CLONED_JOURNEY_REQUEST = `${workflows}/FETCH_CLONED_JOURNEY_REQUEST`;
export const FETCH_CLONED_JOURNEY_RESPONSE = `${workflows}/FETCH_CLONED_JOURNEY_RESPONSE`;
export const FETCH_CLONED_JOURNEY_ERROR = `${workflows}/FETCH_CLONED_JOURNEY_ERROR`;

export const FETCH_EVENT_FIELD_MAPPINGS_REQUEST = `${workflows}/FETCH_EVENT_FIELD_MAPPINGS_REQUEST`;
export const FETCH_EVENT_FIELD_MAPPINGS_RESPONSE = `${workflows}/FETCH_EVENT_FIELD_MAPPINGS_RESPONSE`;
export const FETCH_EVENT_FIELD_MAPPINGS_ERROR = `${workflows}/FETCH_EVENT_FIELD_MAPPINGS_ERROR`;

export const FETCH_TOP_LEVEL_CUSTOM_EVENTS_REQUEST = `${workflows}/FETCH_TOP_LEVEL_CUSTOM_EVENTS_REQUEST`;
export const FETCH_TOP_LEVEL_CUSTOM_EVENTS_RESPONSE = `${workflows}/FETCH_TOP_LEVEL_CUSTOM_EVENTS_RESPONSE`;
export const FETCH_TOP_LEVEL_CUSTOM_EVENTS_ERROR = `${workflows}/FETCH_TOP_LEVEL_CUSTOM_EVENTS_ERROR`;

export const FETCH_CUSTOM_EVENT_MAPPINGS_REQUEST = `${workflows}/FETCH_CUSTOM_EVENT_MAPPINGS_REQUEST`;
export const FETCH_CUSTOM_EVENT_MAPPINGS_RESPONSE = `${workflows}/FETCH_CUSTOM_EVENT_MAPPINGS_RESPONSE`;
export const FETCH_CUSTOM_EVENT_MAPPINGS_ERROR = `${workflows}/FETCH_CUSTOM_EVENT_MAPPINGS_ERROR`;

export const FETCH_USER_MAPPINGS_REQUEST = `${workflows}/FETCH_USER_MAPPINGS_REQUEST`;
export const FETCH_USER_MAPPINGS_RESPONSE = `${workflows}/FETCH_USER_MAPPINGS_RESPONSE`;
export const FETCH_USER_MAPPINGS_ERROR = `${workflows}/FETCH_USER_MAPPINGS_ERROR`;

export const FETCH_SEND_METRICS_REQUEST = `${workflows}/FETCH_SEND_METRICS_REQUEST`;
export const FETCH_SEND_METRICS_RESPONSE = `${workflows}/FETCH_SEND_METRICS_RESPONSE`;
export const FETCH_SEND_METRICS_ERROR = `${workflows}/FETCH_SEND_METRICS_ERROR`;

export const FETCH_VISITOR_COUNTS_REQUEST = `${workflows}/FETCH_VISITOR_COUNTS_REQUEST`;
export const FETCH_VISITOR_COUNTS_RESPONSE = `${workflows}/FETCH_VISITOR_COUNTS_RESPONSE`;
export const FETCH_VISITOR_COUNTS_ERROR = `${workflows}/FETCH_VISITOR_COUNTS_ERROR`;

export const FETCH_FB_CUSTOM_AUDIENCE_REQUEST = `${workflows}/FETCH_FB_CUSTOM_AUDIENCE_REQUEST`;
export const FETCH_FB_CUSTOM_AUDIENCE_RESPONSE = `${workflows}/FETCH_FB_CUSTOM_AUDIENCE_RESPONSE`;
export const FETCH_FB_CUSTOM_AUDIENCE_ERROR = `${workflows}/FETCH_FB_CUSTOM_AUDIENCE_ERROR`;

export const OPEN_MODAL = `${workflows}/OPEN_MODAL`;
export const CLOSE_MODAL = `${workflows}/CLOSE_MODAL`;

export const OPEN_TAKEOVER = `${workflows}/OPEN_TAKEOVER`;
export const CLOSE_TAKEOVER = `${workflows}/CLOSE_TAKEOVER`;

export const UPDATE_IS_ASYNC_LOADING = `${workflows}/UPDATE_IS_ASYNC_LOADING`;

export const UPDATE_CLONED_JOURNEY_ERROR_NODES = `${workflows}/UPDATE_CLONED_JOURNEY_ERROR_NODES`;
export const REMOVE_CLONED_JOURNEY_ERROR_NODE = `${workflows}/REMOVE_CLONED_JOURNEY_ERROR_NODE`;

export const UPDATE_WORKFLOW_VIEW = `${workflows}/UPDATE_WORKFLOW_VIEW`;
/*------------------------------------------------------------------------------------------------*/
/* Journey Visitor Counts                                                                         */
/*------------------------------------------------------------------------------------------------*/

export const FETCH_JOURNEY_VISITOR_METRICS_REQUEST = `${workflows}/FETCH_JOURNEY_VISITOR_METRICS_REQUEST`;
export const FETCH_JOURNEY_VISITOR_METRICS_RESPONSE = `${workflows}/FETCH_JOURNEY_VISITOR_METRICS_RESPONSE`;

/*------------------------------------------------------------------------------------------------*/
/* Workflow Nodes Action Types                                                                    */
/*------------------------------------------------------------------------------------------------*/

/** Individual Node Actions */
export const ADD_NODE = `${workflows}/ADD_NODE`;
export const ADD_NODES = `${workflows}/ADD_NODES`;
export const DELETE_NODE = `${workflows}/DELETE_NODE`;
export const DELETE_NODES = `${workflows}/DELETE_NODES`;
export const SELECT_NODES = `${workflows}/SELECT_NODES`;
export const SELECT_GEN_AI_NODES = `${workflows}/SELECT_GEN_AI_NODES`;
export const DESELECT_NODES = `${workflows}/DESELECT_NODES`;
export const DESELECT_NODE = `${workflows}/DESELECT_NODE`;
export const UPDATE_NODE = `${workflows}/UPDATE_NODE`;
export const ADD_NODE_ERRORS = `${workflows}/ADD_NODE_ERRORS`;
export const REMOVE_NODE_ERROR = `${workflows}/REMOVE_NODE_ERROR`;
export const UPDATE_NODE_COMBO_ID = `${workflows}/UPDATE_NODE_COMBO_ID`;
export const UPDATE_NODES = `${workflows}/UPDATE_NODES`;
export const UPDATE_NODE_DATA = `${workflows}/UPDATE_NODE_DATA`;
export const REASSIGN_NODE_ID = `${workflows}/REASSIGN_NODE_ID`;

export const OPEN_NODE_REQUEST = `${workflows}/OPEN_NODE_REQUEST`;
export const OPEN_NODE_RESPONSE = `${workflows}/OPEN_NODE_RESPONSE`;
export const OPEN_NODE_ERROR = `${workflows}/OPEN_NODE_ERROR`;

export const CLOSE_NODE = `${workflows}/CLOSE_NODE`;

/** Bulk Node Actions */
export const CLONE_NODES = `${workflows}/CLONE_NODES`;

/*------------------------------------------------------------------------------------------------*/
/* Workflow Edges Action Types                                                                    */
/*------------------------------------------------------------------------------------------------*/

export const ADD_EDGE = `${workflows}/ADD_EDGE`;
export const ADD_EDGES = `${workflows}/ADD_EDGES`;
export const CLONE_EDGES = `${workflows}/CLONE_EDGES`;
export const DELETE_EDGE = `${workflows}/DELETE_EDGE`;
export const DELETE_EDGES = `${workflows}/DELETE_EDGES`;

/*------------------------------------------------------------------------------------------------*/
/* Beta Management                                                                                */
/*------------------------------------------------------------------------------------------------*/

export const FETCH_BETA_NODES_REQUEST = `${workflows}/FETCH_BETA_NODES_REQUEST`;
export const FETCH_BETA_NODES_RESPONSE = `${workflows}/FETCH_BETA_NODES_RESPONSE`;
export const FETCH_BETA_NODES_ERROR = `${workflows}/FETCH_BETA_NODES_ERROR`;

export const GO_TO_CLASSIC_STUDIO = `${workflows}/GO_TO_CLASSIC_STUDIO`;

/* ---------------------------------------------------------------------------------------------- */
/* Notes                                                                                          */
/* ---------------------------------------------------------------------------------------------- */

export const UPDATE_IS_NOTES_FEATURE_ENABLED = `${workflows}/UPDATE_IS_NOTES_FEATURE_ENABLED`;
export const UPDATE_IS_NOTES_INLINE_EDIT_ENABLED = `${workflows}/UPDATE_IS_NOTES_INLINE_EDIT_ENABLED`;
export const UPDATE_NOTES_VISIBILITY = `${workflows}/UPDATE_NOTES_VISIBILITY`;
export const TOGGLE_NOTES_VISIBILITY = `${workflows}/TOGGLE_NOTES_VISIBILITY`;
export const SHOW_NOTES = `${workflows}/SHOW_NOTES`;
export const HIDE_NOTES = `${workflows}/HIDE_NOTES`;

/* -------------------------------------------------------------------------- */
/*                                Feature Flags                               */
/* -------------------------------------------------------------------------- */
export const UPDATE_IS_QUIET_HOURS_FEATURE_ENABLED = `${workflows}/UPDATE_IS_QUIET_HOURS_FEATURE_ENABLED`;
export const UPDATE_IS_YES_NO_SPLIT_DATA_TOGGLE_FEATURE_ENABLED = `${workflows}/UPDATE_IS_YES_NO_SPLIT_DATA_TOGGLE_FEATURE_ENABLED`;
export const UPDATE_IS_METRICS_SELECTION_ENABLED = `${workflows}/UPDATE_IS_METRICS_SELECTION_ENABLED`;
export const UPDATE_IS_IN_PROGRESS_TOTAL_PUBLISHED_VIEW_ENABLED = `${workflows}/UPDATE_IS_IN_PROGRESS_TOTAL_PUBLISHED_VIEW_ENABLED`;

/* ---------------------------------------------------------------------------------------------- */
/* Tilesets                                                                                        */
/* ---------------------------------------------------------------------------------------------- */
export const IMPORT_TILESET = `${workflows}/IMPORT_TILESET`;

/* ---------------------------------------------------------------------------------------------- */
/* Lists                                                                                        */
/* ---------------------------------------------------------------------------------------------- */
export const CREATE_LIST_REQUEST = `${workflows}/CREATE_LIST_REQUEST`;
/**
 * MISC
 */
export const UPDATE_PROJECT_TIMEZONE = `${workflows}/UPDATE_PROJECT_TIMEZONE`;
